import { ApolloLink } from '@apollo/client';

export const logTimeLink = new ApolloLink((operation, forward) => {
  return forward(operation);
});
